import styled from 'styled-components';

import mediaQueries from '@/theme/mediaQueries';

export const Container = styled.div`
    padding: 48px;
    margin-top: 120px;
    text-align: center;

    ${mediaQueries.laptop} {
        margin-top: 24px;
    }
`;
